import React, {useContext} from 'react';
import {Modal} from 'react-native';
import {StoreContext} from "../components/StoreContextProvider";
import Div from "../lib/Div";
import {colors} from "../assets/styles/colors";
import P from "../lib/P";

const SuccessModal = () => {
  const {isSuccessMessageShow, setIsSuccessMessageShow} = useContext(StoreContext);

  return (
    <Modal animationType="fade" transparent={true} visible={!!isSuccessMessageShow} statusBarTranslucent={false}
           hardwareAccelerated={false} onRequestClose={() => setIsSuccessMessageShow('')}>
      <Div flex={1} alignItems="center" justifyContent="center" px={9}>
        <Div bg={colors.layoutBg} rounded={5} p={20}>
          <P fs={25} ta="center" color={colors.lightText}>{isSuccessMessageShow}</P>
        </Div>
      </Div>
    </Modal>
  );
};

export default React.memo(SuccessModal);
